export default __webpack_public_path__ + "static/media/choose_3.2cc0818e.png";